'use client'
import { ROUTES } from '@/core/constants/routes'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { Product } from '@/features/product/model/product.model'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

interface CategoryCardProps {
  title: string
  products: Product[]
  eventId: number
}
export function EventCard({ title, products, eventId }: CategoryCardProps) {
  const t = useTranslations()
  return (
    <div className='rounded-lg bg-white p-4 shadow-sm transition-shadow hover:shadow-xl'>
      <h3 className='text-app-foreground mb-3 text-lg font-bold'>{title}</h3>
      <div className='mb-3 grid grid-cols-2 gap-3'>
        {products?.slice(0, 4).map((item, index) => (
          <Link key={index} href={`/products/${item.slug}`} className='group'>
            <div
              style={{
                width: '100%',
                maxWidth: '126px',
                aspectRatio: '1 / 1',
              }}
              className='bg-secondary relative mb-1 aspect-square overflow-hidden rounded-md'
            >
              <RemoteImage
                width={126}
                height={126}
                src={item?.media?.preview_url}
                alt={item.name}
                className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105'
              />
            </div>

            <p className='text-muted-foreground group-hover:text-creamed-cron line-clamp-1 text-xs transition-colors'>
              {item.name}
            </p>
          </Link>
        ))}
      </div>
      <Link
        href={`${ROUTES.search}${`?events[]=${eventId}`}`}
        className='text-creamed-cron hover:text-creamed-cron/80 text-sm font-medium hover:underline'
      >
        {t('actions.viewAll')}
      </Link>
    </div>
  )
}
